import { variables } from '@benefits/environment';
import { hotjar } from 'react-hotjar';

const hotjarInitialize = () => hotjar.initialize(variables.NEXT_PUBLIC_HOTJAR_ID, 6);

export { hotjarInitialize, hotjar };
